import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAutosaveIntervalMinutes, setHideParameterLabelsDefault, setAttributeLabelSeparator } from '../../../../redux/reducers/global/view/viewSlice';
import { setAllNodesHideAttributeLabels } from '../../../../redux/reducers/global/node/nodeSlice';
import './SettingsModalContent.css';

const AUTOSAVE_OPTIONS = [
  { value: 1, label: 'Cada 1 minuto' },
  { value: 5, label: 'Cada 5 minutos' },
  { value: 10, label: 'Cada 10 minutos' },
];

const SettingsModalContent = ({ onClose }) => {
  const dispatch = useDispatch();
  const currentInterval = useSelector((state) => state.view.autosaveIntervalMinutes ?? 5);
  const hideParamsDefault = useSelector((state) => !!state.view.hideParameterLabelsDefault);
  const currentAttributeSeparator = useSelector((state) => state.view.attributeLabelSeparator ?? ':');
  const [selectedInterval, setSelectedInterval] = useState(currentInterval);
  const [hideParametersDefault, setHideParametersDefault] = useState(hideParamsDefault);
  const [attributeSeparator, setAttributeSeparator] = useState(currentAttributeSeparator);

  useEffect(() => {
    setSelectedInterval(currentInterval);
  }, [currentInterval]);

  useEffect(() => {
    setHideParametersDefault(hideParamsDefault);
  }, [hideParamsDefault]);
  useEffect(() => {
    setAttributeSeparator(currentAttributeSeparator);
  }, [currentAttributeSeparator]);

  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(setAutosaveIntervalMinutes(selectedInterval));
    dispatch(setHideParameterLabelsDefault(hideParametersDefault));
    dispatch(setAllNodesHideAttributeLabels(hideParametersDefault));
    dispatch(setAttributeLabelSeparator(attributeSeparator));
    onClose();
  };

  return (
    <div className="settings-modal">
      <h2>Configuración</h2>
      <form className="settings-form" onSubmit={handleSubmit}>
        <label className="settings-field">
          <span>Guardado automático</span>
          <select
            value={selectedInterval}
            onChange={(e) => setSelectedInterval(Number(e.target.value))}
          >
            {AUTOSAVE_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
        <p className="settings-hint">
          Selecciona cada cuánto tiempo se guarda automáticamente el diagrama mientras trabajas.
        </p>
        <label className="settings-field">
          <span>Símbolo despues del atributo</span>
          <input
            type="text"
            value={attributeSeparator}
            onChange={(e) => setAttributeSeparator(e.target.value)}
          />
        </label>
        <label className="settings-field settings-field--checkbox">
          <span>Esconder nombre de los parámetros por defecto</span>
          <div className="settings-checkbox-wrapper">
            <input
              type="checkbox"
              checked={hideParametersDefault}
              onChange={(e) => setHideParametersDefault(e.target.checked)}
            />
            <span>Cuando se active, los nuevos elementos ocultarán los nombres de los parámetros en el inspector.</span>
          </div>
        </label>
        <div className="modal-buttons">
          <button type="button" className="btn-cancel" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" className="btn-submit">
            Guardar
          </button>
        </div>
      </form>
    </div>
  );
};

export default SettingsModalContent;
